module.exports = __webpack_public_path__ + "static/media/logoZH.3cdd2905.svg";